// extracted by mini-css-extract-plugin
module.exports = {"publicationRow":"Publication_publicationRow__3taiJ","treebankWrapper":"Publication_treebankWrapper__2KYz-"};